export const Download = {
    methods: {
        download(data, type, filename) {
            const blob = new Blob([data], {type});

            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                // IE doesn't allow using a blob object directly as link href.
                // Workaround for "HTML7007: One or more blob URLs were
                // revoked by closing the blob for which they were created.
                // These URLs will no longer resolve as the data backing
                // the URL has been freed."
                window.navigator.msSaveBlob(blob, filename);
                return;
            }
            const blobURL = window.URL.createObjectURL(blob);
            const l = document.createElement('a');
            l.href = blobURL;
            l.setAttribute('download', filename);
            if (typeof l.download === 'undefined') {
                l.setAttribute('target', '_blank');
            }
            document.body.appendChild(l);
            l.click();
            document.body.removeChild(l);
            setTimeout(() => {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(blobURL);
            }, 100);
        }
    }
};